import { getOrCreateGlobalContext, CONTEXT_NAMES } from '@adsk/alloy-react-context';
export default getOrCreateGlobalContext(CONTEXT_NAMES.LocaleContext);
//# sourceMappingURL=context.js.map